import { render, staticRenderFns } from "./preTable2.vue?vue&type=template&id=7b773d27&scoped=true&"
import script from "./preTable2.vue?vue&type=script&lang=js&"
export * from "./preTable2.vue?vue&type=script&lang=js&"
import style0 from "./preTable2.vue?vue&type=style&index=0&id=7b773d27&prod&lang=scss&"
import style1 from "./preTable2.vue?vue&type=style&index=1&id=7b773d27&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b773d27",
  null
  
)

export default component.exports